import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const AddBeneficiaryBankDetails = ({
	isEditable,
	onAddBeneficiaryBank,
	selectedItem,
	getSalesContractDetailsInfo,
	supplierId,
	isFromSupplier,
	onResetSelectedItem
}) => {
	const [show, setShow] = useState(true);
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);

	const [addressInfo, setaAddressInfo] = useState({
		id: selectedItem?.id ? selectedItem.id : null,
		title: selectedItem?.title ? selectedItem.title : '',
		swiftCode: selectedItem?.swiftCode ? selectedItem.swiftCode : '',
		name: selectedItem?.name ? selectedItem.name : '',
		bankName: selectedItem?.bankName ? selectedItem.bankName : '',
		bankDetails: selectedItem?.bankDetails ? selectedItem.bankDetails : '',
		accountNumber: selectedItem?.accountNumber ? selectedItem.accountNumber : ''
	});
	const [errors, setErrors] = useState({});

	const onCloseModal = () => {
		if (isEditable) {
			onResetSelectedItem();
		}
		setShow(false);
		onAddBeneficiaryBank();
	};

	const onResetValidation = (type) => {
		switch (type) {
			case 'title':
				setErrors({ ...errors, titleError: '' });
				break;
			case 'name':
				setErrors({ ...errors, nameError: '' });
				break;
			case 'accountNumber':
				setErrors({ ...errors, accountNumberError: '' });
				break;
			case 'bankName':
				setErrors({ ...errors, bankNameError: '' });
				break;
			case 'swiftCode':
				setErrors({ ...errors, swiftCodeError: '' });
				break;
			default:
				break;
		}
	};

	const onChangeAddressInfo = (e) => {
		let { id, value } = e.target;
		setaAddressInfo({ ...addressInfo, [id]: value });
		onResetValidation(id);
	};

	const isValidForm = (body) => {
		if (body.title === '' || !body.title) {
			setErrors({ ...errors, titleError: 'Title is required' });
			return false;
		}
		if (body.name === '' || !body.name) {
			setErrors({ ...errors, nameError: 'Account name is required' });
			return false;
		}
		if (body.accountNumber === '' || !body.accountNumber) {
			setErrors({ ...errors, accountNumberError: 'Account number is required' });
			return false;
		}
		if (body.bankName === '' || !body.bankName) {
			setErrors({ ...errors, bankNameError: 'Bank name is required.' });
			return false;
		}
		if (body.swiftCode === '' || !body.swiftCode) {
			setErrors({ ...errors, swiftCodeError: 'Swift code is required.' });
			return false;
		}
		return true;
	};

	const onAddLocation = async () => {
		setIsSubmitLoading(true);
		const isValid = isValidForm(addressInfo);
		if (!isValid) {
			setIsSubmitLoading(false);
			return;
		}
		let postData = { ...addressInfo };
		postData['id'] = null;
		await ApiClient.POST('addSupplierBankDetails', postData, supplierId)
			.then(() => {
				setIsSubmitLoading(false);
				if (isFromSupplier) {
					getSalesContractDetailsInfo(supplierId);
				} else {
					getSalesContractDetailsInfo(selectedItem.id);
				}

				onCloseModal();
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
				onCloseModal();
			});
	};

	const onUpdateLocation = async () => {
		setIsSubmitLoading(true);
		const isValid = isValidForm(addressInfo);
		if (!isValid) {
			setIsSubmitLoading(false);
			return;
		}
		await ApiClient.PUT('updateBankDetails', addressInfo, addressInfo.id)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					getSalesContractDetailsInfo(supplierId);
					onCloseModal();
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
				onCloseModal();
			});
	};

	const onSubmit = () => {
		if (isEditable) {
			onUpdateLocation();
		} else {
			onAddLocation();
		}
	};

	return (
		<LoaderComponent active={isSubmitLoading}>
			<Modal show={show} backdrop="static" onHide={onCloseModal} centered>
				<div className="common-popup shadow-24dp">
					<Modal.Header closeButton>
						<h3 className="semibold-16 mb-0">Add Bank details</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="title">Title*</label>
											<input
												type="text"
												autoComplete="off"
												id="title"
												value={addressInfo?.title}
												onChange={onChangeAddressInfo}
											/>
											{errors.titleError && (
												<p className="error">{errors.titleError}</p>
											)}
										</div>
									</div>

									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="name">Account holder name*</label>
											<input
												type="text"
												autoComplete="off"
												id="name"
												value={addressInfo?.name}
												onChange={onChangeAddressInfo}
											/>
											{errors.nameError && <p className="error">{errors?.nameError}</p>}
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="accountNumber">Account number*</label>
											<input
												type="text"
												autoComplete="off"
												id="accountNumber"
												value={addressInfo?.accountNumber}
												onChange={onChangeAddressInfo}
											/>
											{errors.accountNumberError && (
												<p className="error">{errors.accountNumberError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="bname">Bank name*</label>
											<input
												type="text"
												autoComplete="off"
												id="bankName"
												value={addressInfo?.bankName}
												onChange={onChangeAddressInfo}
											/>
											{errors.bankNameError && (
												<p className="error">{errors.bankNameError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="swiftCode">Swift code*</label>
											<input
												type="text"
												autoComplete="off"
												id="swiftCode"
												value={addressInfo?.swiftCode}
												onChange={onChangeAddressInfo}
											/>
											{errors.swiftCodeError && (
												<p className="error">{errors.swiftCodeError}</p>
											)}
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-0">
											<label htmlFor="bankDetails">Bank details</label>
											<textarea
												name="bankDetails"
												placeholder="Write description"
												id="bankDetails"
												value={addressInfo?.bankDetails}
												onChange={onChangeAddressInfo}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={onCloseModal}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								disabled={isSubmitLoading}
								onClick={onSubmit}
							>
								Submit
							</button>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default AddBeneficiaryBankDetails;
